import React, { useState } from 'react';
import '../../styles/ConfirmModal.scss';

interface ReportModalProps {
  isOpen: boolean;
  onConfirm: (reason: string, detail: string) => void;
  onCancel: () => void;
}

const REPORT_REASONS = [
  "욕설·비방",
  "광고·스팸",
  "부적절한 콘텐츠",
  "개인정보 노출",
  "기타"
];

const ReportModal: React.FC<ReportModalProps> = ({
  isOpen,
  onConfirm,
  onCancel,
}) => {
  const [reason, setReason] = useState(REPORT_REASONS[0]);
  const [detail, setDetail] = useState('');

  if (!isOpen) return null;

  const handleConfirm = () => {
    onConfirm(reason, detail);
    // 초기화
    setReason(REPORT_REASONS[0]);
    setDetail('');
  };

  return (
    <div className="confirm-modal-overlay">
      <div className="confirm-modal-content" style={{ width: '400px', textAlign: 'left' }}>
        <h2 style={{ textAlign: 'center' }}>신고하기</h2>
        
        <div style={{ marginBottom: '20px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
          <div>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 600, fontSize: '0.9rem' }}>신고 사유</label>
            <select 
              value={reason} 
              onChange={(e) => setReason(e.target.value)}
              style={{ 
                width: '100%', 
                padding: '10px', 
                borderRadius: '6px', 
                border: '1px solid #ddd',
                fontSize: '1rem'
              }}
            >
              {REPORT_REASONS.map(r => (
                <option key={r} value={r}>{r}</option>
              ))}
            </select>
          </div>

          {reason === '기타' && (
            <div>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: 600, fontSize: '0.9rem' }}>상세 내용</label>
              <textarea 
                value={detail}
                onChange={(e) => setDetail(e.target.value)}
                placeholder="신고 사유를 입력해주세요."
                rows={3}
                style={{ 
                  width: '100%', 
                  padding: '10px', 
                  borderRadius: '6px', 
                  border: '1px solid #ddd',
                  resize: 'none',
                  fontSize: '1rem'
                }}
              />
            </div>
          )}
        </div>

        <div className="modal-actions">
          <button className="btn-cancel" onClick={onCancel}>
            취소
          </button>
          <button className="btn-confirm" onClick={handleConfirm} style={{ backgroundColor: '#ff4d4f' }}>
            신고
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReportModal;
